import gql from 'graphql-tag';

const LOG_OUT = gql`
  mutation logOut {
    logOut
  }
`;

export default LOG_OUT;
